import React from 'react'
import {InfusionsoftTag, useTestTag} from 'Event/infusionsoft'
import {INFUSIONSOFT} from 'organization/Event/Services/ServicesProvider'
import TestTagButton from 'organization/Event/Form/TestTagButton'

export default function TestInfusionsoftTagButton(props: {
  tag: InfusionsoftTag | null
}) {
  const addTag = useTestTag()

  return (
    <TestTagButton tag={props.tag} integration={INFUSIONSOFT} addTag={addTag} />
  )
}
